import React, { FC } from "react";
import { Box } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { media } from "@utils/media";
import { BackgroundProps } from ".";

export const LongSpiralBG: FC<BackgroundProps> = ({
  color = "blue",
  left = "none",
  right = "none",
  top = "none",
  bottom = "none",
  height = "full",
  pos = "absolute",
  sx = undefined,
}) => {
  return (
    <Box
      zIndex={-1}
      w="full"
      pos={pos}
      h={height}
      top={top}
      left={left}
      right={right}
      bottom={bottom}
      sx={{
        display: "block",
        [media.desktop]: {
          display: "none",
        },
        ...(sx ?? {}),
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        fill="none"
      >
        <motion.path
          d="M1092.52 974.902C794.509 1088.69 361.893 1140.62 182.782 881.46C-170.485 370.32 190.923 -94.7804 663.822 76.5201C1035.13 211.02 1013.86 506.265 871.028 634.598"
          fill="transparent"
          strokeWidth="80"
          stroke={color}
          strokeLinecap="square"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{
            duration: 1,
            yoyo: Infinity,
            ease: "easeInOut",
          }}
        />
      </svg>
    </Box>
  );
};
